import _slicedToArray from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { UnknownFieldHandler, WireType } from "./binary-format-contract";
import { RepeatType, ScalarType } from "./reflection-info";
import { assert } from "./assert";
import { PbLong, PbULong } from "./pb-long";
/**
 * Writes proto3 messages in binary format using reflection information.
 *
 * https://developers.google.com/protocol-buffers/docs/encoding
 */

export var ReflectionBinaryWriter = /*#__PURE__*/function () {
  function ReflectionBinaryWriter(info) {
    _classCallCheck(this, ReflectionBinaryWriter);

    this.info = info;
  }

  _createClass(ReflectionBinaryWriter, [{
    key: "prepare",
    value: function prepare() {
      if (!this.fields) {
        var fieldsInput = this.info.fields ? this.info.fields.concat() : [];
        this.fields = fieldsInput.sort(function (a, b) {
          return a.no - b.no;
        });
      }
    }
    /**
     * Writes the message to binary format.
     */

  }, {
    key: "write",
    value: function write(message, writer, options) {
      this.prepare();

      var _iterator = _createForOfIteratorHelper(this.fields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          var value = void 0,
              // this will be our field value, whether it is member of a oneof or not
          emitDefault = void 0,
              // whether we emit the default value (only true for oneof members)
          repeated = field.repeat,
              localName = field.localName; // handle oneof ADT

          if (field.oneof) {
            var group = message[field.oneof];
            if (group.oneofKind !== localName) continue; // if field is not selected, skip

            value = group[localName];
            emitDefault = true;
          } else {
            value = message[localName];
            emitDefault = false;
          } // we have handled oneof above. we just have to honor `emitDefault`.


          switch (field.kind) {
            case "scalar":
            case "enum":
              var T = field.kind == "enum" ? ScalarType.INT32 : field.T;

              if (repeated) {
                assert(Array.isArray(value));
                if (repeated == RepeatType.PACKED) this.packed(writer, T, field.no, value);else {
                  var _iterator2 = _createForOfIteratorHelper(value),
                      _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var item = _step2.value;
                      this.scalar(writer, T, field.no, item, true);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }
              } else if (value === undefined) assert(field.opt);else this.scalar(writer, T, field.no, value, emitDefault || field.opt);

              break;

            case "message":
              if (repeated) {
                assert(Array.isArray(value));

                var _iterator3 = _createForOfIteratorHelper(value),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var _item = _step3.value;
                    this.message(writer, options, field.T(), field.no, _item);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              } else {
                this.message(writer, options, field.T(), field.no, value);
              }

              break;

            case "map":
              assert(typeof value == 'object' && value !== null);

              for (var _i = 0, _Object$entries = Object.entries(value); _i < _Object$entries.length; _i++) {
                var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                    key = _Object$entries$_i[0],
                    val = _Object$entries$_i[1];

                this.mapEntry(writer, options, field, key, val);
              }

              break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u === true ? UnknownFieldHandler.onWrite : u)(this.info.typeName, message, writer);
    }
  }, {
    key: "mapEntry",
    value: function mapEntry(writer, options, field, key, value) {
      writer.tag(field.no, WireType.LengthDelimited);
      writer.fork(); // javascript only allows number or string for object properties
      // we convert from our representation to the protobuf type

      var keyValue = key;

      switch (field.K) {
        case ScalarType.INT32:
        case ScalarType.FIXED32:
        case ScalarType.UINT32:
        case ScalarType.SFIXED32:
        case ScalarType.SINT32:
          keyValue = Number.parseInt(key);
          break;

        case ScalarType.BOOL:
          assert(key == 'true' || key == 'false');
          keyValue = key == 'true';
          break;
      } // write key, expecting key field number = 1


      this.scalar(writer, field.K, 1, keyValue, true); // write value, expecting value field number = 2

      switch (field.V.kind) {
        case 'scalar':
          this.scalar(writer, field.V.T, 2, value, true);
          break;

        case 'enum':
          this.scalar(writer, ScalarType.INT32, 2, value, true);
          break;

        case 'message':
          this.message(writer, options, field.V.T(), 2, value);
          break;
      }

      writer.join();
    }
  }, {
    key: "message",
    value: function message(writer, options, handler, fieldNo, value) {
      if (value === undefined) return;
      handler.internalBinaryWrite(value, writer.tag(fieldNo, WireType.LengthDelimited).fork(), options);
      writer.join();
    }
    /**
     * Write a single scalar value.
     */

  }, {
    key: "scalar",
    value: function scalar(writer, type, fieldNo, value, emitDefault) {
      var _this$scalarInfo = this.scalarInfo(type, value),
          _this$scalarInfo2 = _slicedToArray(_this$scalarInfo, 3),
          wireType = _this$scalarInfo2[0],
          method = _this$scalarInfo2[1],
          isDefault = _this$scalarInfo2[2];

      if (!isDefault || emitDefault) {
        writer.tag(fieldNo, wireType);
        writer[method](value);
      }
    }
    /**
     * Write an array of scalar values in packed format.
     */

  }, {
    key: "packed",
    value: function packed(writer, type, fieldNo, value) {
      if (!value.length) return;
      assert(type !== ScalarType.BYTES && type !== ScalarType.STRING); // write tag

      writer.tag(fieldNo, WireType.LengthDelimited); // begin length-delimited

      writer.fork(); // write values without tags

      var _this$scalarInfo3 = this.scalarInfo(type),
          _this$scalarInfo4 = _slicedToArray(_this$scalarInfo3, 2),
          method = _this$scalarInfo4[1];

      for (var i = 0; i < value.length; i++) {
        writer[method](value[i]);
      } // end length delimited


      writer.join();
    }
    /**
     * Get information for writing a scalar value.
     *
     * Returns tuple:
     * [0]: appropriate WireType
     * [1]: name of the appropriate method of IBinaryWriter
     * [2]: whether the given value is a default value
     *
     * If argument `value` is omitted, [2] is always false.
     */

  }, {
    key: "scalarInfo",
    value: function scalarInfo(type, value) {
      var t = WireType.Varint;
      var m;
      var i = value === undefined;
      var d = value === 0;

      switch (type) {
        case ScalarType.INT32:
          m = "int32";
          break;

        case ScalarType.STRING:
          d = i || !value.length;
          t = WireType.LengthDelimited;
          m = "string";
          break;

        case ScalarType.BOOL:
          d = value === false;
          m = "bool";
          break;

        case ScalarType.UINT32:
          m = "uint32";
          break;

        case ScalarType.DOUBLE:
          t = WireType.Bit64;
          m = "double";
          break;

        case ScalarType.FLOAT:
          t = WireType.Bit32;
          m = "float";
          break;

        case ScalarType.INT64:
          d = i || PbLong.from(value).isZero();
          m = "int64";
          break;

        case ScalarType.UINT64:
          d = i || PbULong.from(value).isZero();
          m = "uint64";
          break;

        case ScalarType.FIXED64:
          d = i || PbULong.from(value).isZero();
          t = WireType.Bit64;
          m = "fixed64";
          break;

        case ScalarType.BYTES:
          d = i || !value.byteLength;
          t = WireType.LengthDelimited;
          m = "bytes";
          break;

        case ScalarType.FIXED32:
          t = WireType.Bit32;
          m = "fixed32";
          break;

        case ScalarType.SFIXED32:
          t = WireType.Bit32;
          m = "sfixed32";
          break;

        case ScalarType.SFIXED64:
          d = i || PbLong.from(value).isZero();
          t = WireType.Bit64;
          m = "sfixed64";
          break;

        case ScalarType.SINT32:
          m = "sint32";
          break;

        case ScalarType.SINT64:
          d = i || PbLong.from(value).isZero();
          m = "sint64";
          break;
      }

      return [t, m, i || d];
    }
  }]);

  return ReflectionBinaryWriter;
}();